import React from 'react';
import Link from 'gatsby-link';
import NewsletterSignup from '../components/NewsletterSignup';

function Card({ children }) {
  return (
    <div
      style={{
        border: 'thin solid #484848',
        borderRadius: 10,
        paddingLeft: 22,
        paddingRight: 22,
        margin: '20px 0',
      }}
      className="shadow-hover"
    >
      {children}
    </div>
  );
}

const GOALS = [
  {
    title: 'Find a partner',
    link: '/goals/find-a-partner',
    subtitle:
      "We've talked with dozens of dating experts, poured through books and online communities, and conducted our own research, to understand how you can be your best self and find a partner in the ever-digital dating scene of 2018.",
    crediblePrediction:
      '75% of users who use our guide in addition to our plan find a partner within a year that they report being extremely satisfied with.',
  },
  {
    title: 'Be healthy',
    link: '/goals/be-healthy',
    subtitle:
      "We'll walk you step by step through the most tried and trued ways of achieving physical fitness, and arriving at a body you feel happy to inhabit.",
    crediblePrediction:
      'Depending on the track you take in our program, 80% achieve their target weight and 84% their target resting heart rate.',
  },
  {
    title: 'Live longer',
    link: '/goals/live-longer',
    subtitle:
      "Longevity is traditionally a difficult and painful goal, where you toil away for years without understanding your progress. We'll introduce you to cutting-edge techniques and methods for measuring progress so that you know you're on the right track within weeks of starting.",
    crediblePrediction: '',
  },
];

const IndexPage = () => (
  <div>
    <div className="mw7 f5">
      <p className="">
        Welcome to Terminus, where we investigate and collect the best ways of achieving your
        <span className="b"> biggest, most ambitious goals.</span>
      </p>

      <p>
        Our experts have spent hundreds of hours researching (and doing!) these goals, to find out
        what works, and what doesn't, so you can jump straight in.{' '}
        <Link className="link black hover-bg-light-gray underline" to="/our-process">
          Read more about our process and program.
        </Link>
      </p>
    </div>

    <div className="mw7 pt1">
      <div className="">
        <h2>Our goals</h2>
      </div>
      {GOALS.map(({
 title, subtitle, link, crediblePrediction,
}) => (
  <Link to={link} style={{ textDecoration: 'none', color: 'inherit' }}>
    <Card>
      <p className="serif" style={{ fontSize: 20, fontWeight: 'bold' }}>
        {title}
      </p>
      <p style={{ marginTop: 10, fontSize: 16 }}>{subtitle}</p>
      <p className="b">{crediblePrediction}</p>
    </Card>
  </Link>
      ))}

      <NewsletterSignup />
    </div>
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js